/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  Alert,
  ALERT_TYPE_WARNING,
  ICON_EXPAND_LESS,
  ICON_EXPAND_MORE,
  SdsText,
  SdsTextSize,
  SdsTextWeight,
} from '@squiz/sds';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EntityFileExplorerItem, VirusScanStatusType } from '../../../../../../Services/file-store';
import { FILE_EXPLORER_STRINGS } from '../../FileExplorer.constants';
import { useFileExplorerStore } from '../../FileExplorer.state';

export const InfectionAlert = (): JSX.Element => {
  const { t } = useTranslation();
  const { directoryContents } = useFileExplorerStore();

  const [quarantinedFiles, setQuarantinedFiles] = useState<Array<EntityFileExplorerItem>>([]);
  const [quarantinedAlertExpanded, setQuarantinedAlertExpanded] = useState<boolean>(false);

  const labels = {
    virusWarning: t(FILE_EXPLORER_STRINGS.virusDeleteWarning),
    virusWarningBold: t(FILE_EXPLORER_STRINGS.virusDeleteWarningBold),
  };

  const handleAlertCollapse = (): void => {
    setQuarantinedAlertExpanded(!quarantinedAlertExpanded);
  };

  useEffect(() => {
    setQuarantinedFiles(directoryContents.filter((item) => item.virusScanStatus === VirusScanStatusType.Quarantined));
  }, [directoryContents]);

  return (
    <>
      {quarantinedFiles.length > 0 && (
        <div className="file-explorer-infection-alert">
          <button className="file-explorer-infection-alert__expander" onClick={handleAlertCollapse}>
            <Alert
              message={
                <div>
                  <span>
                    <SdsText
                      fontSize={SdsTextSize.Medium}
                      fontWeight={SdsTextWeight.Semibold}
                      text={`${quarantinedFiles.length} ${labels.virusWarningBold} `}
                    />
                    <SdsText fontSize={SdsTextSize.Medium} text={`${labels.virusWarning}`} />
                  </span>
                  {quarantinedAlertExpanded && (
                    <ul>
                      {quarantinedFiles.map((file) => {
                        const filePathSplit = file.path.split('/');
                        const fileName = filePathSplit.pop() + '';
                        return (
                          <li key={file.id}>
                            {filePathSplit.join('/')}
                            /
                            <SdsText
                              fontSize={SdsTextSize.Medium}
                              fontWeight={SdsTextWeight.Semibold}
                              text={fileName}
                            />
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </div>
              }
              type={ALERT_TYPE_WARNING}
            />
            <div className="file-explorer-infection-alert__expand-icon">
              {quarantinedAlertExpanded ? ICON_EXPAND_LESS : ICON_EXPAND_MORE}
            </div>
          </button>
        </div>
      )}
    </>
  );
};
